<template>
  <div class="popup">
    <sweet-modal ref="popupModal" overlay-theme="dark" @close="$emit('close')" hideCloseButton>
      <div v-if="popup && popup.length===1" :style="[bgCoverStyle(popup[0]),popupStyle]" @click="clickPopup"></div>
      <div class="full-width" v-if="popup && popup.length>1">
        <image-slider
          :listData="popup" :height="height" :autoplay="true"
          :indicator="true" :imageRates="{ratio: '3:4'}"
          @reRender="$refs.popupModal.open()"></image-slider>
      </div>
      <div class="flex">
        <div class="close-area size-14 unselect"
             style="color:#4f4f4f"
             @click="offToday">오늘 그만 보기</div>
        <div class="close-area size-14 unselect"
             style="color:#ff5722"
             @click="offPopup">닫기</div>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
  import { SweetModal } from 'sweet-modal-vue'
  import ImageSlider from "./ImageSlider";

  export default {
    name: "PopupPreview",
    components: {
      ImageSlider,
      SweetModal,
    },
    props: {
      popup: {
        type: [Object, Array]
      }
    },
    data() {
      return {
        height: 0,
        usePopup: false,
      }
    },
    created() {
      this.height = 420*4/3;
    },
    mounted() {
      this.$refs.popupModal.open();
    },
    methods: {
      bgCoverStyle(url) {
        return {
          backgroundImage: `url(${url})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }
      },
      clickPopup() {
        let link = this.popup[0].link;
        if(link) {
          if (link.indexOf('http:') > -1 || link.indexOf('https:') > -1) {
            if (link.indexOf(location.origin) > -1) {
              this.routerPush(link.replace(location.origin, ''));
            } else {
              const a = document.createElement("a");
              a.href = link;
              a.setAttribute('target', '_blank');
              a.style.display = 'none';
              document.body.appendChild(a);
              a.click();
              a.parentNode.removeChild(a);
            }
          } else {
            // location.href = link;
            this.routerPush(link);
          }
        }
      },
      offToday() {
        this.$refs.popupModal.close();
      },
      offPopup() {
        this.$refs.popupModal.close();
      }
    },
    computed: {
      popupStyle() {
        return {
          height: 'calc(420px * 4/3)'
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

  .close-area
    width 50%
    padding 12px
    text-align center
</style>
<style lang="stylus">
  .popup .sweet-modal.is-alert .sweet-content
    padding 0 !important
  .popup .sweet-modal.is-alert
    width 420px !important
  @media screen and (max-width: 600px)
    .popup .sweet-modal.is-alert
      width 320px !important
</style>
